import { ImageScaleViewOpts } from '@play-co/timestep-core/lib/ui/ImageScaleView';
import { ImageScaleView, View } from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import i18n from 'src/lib/i18n/i18n';
import {
  Match2Booster,
  Match2BoosterType,
} from 'src/replicant/match2/match2.ruleset';
import { assertNever } from 'src/replicant/utils';
import { matchTheme } from 'src/game/theme/match2/Match2Theme';

type BoosterPanelOpts = Omit<ImageScaleViewOpts, 'image' | 'width' | 'height'>;

export class BoosterPanel extends ImageScaleView {
  constructor(booster: Match2Booster, opts: BoosterPanelOpts = {}) {
    super({
      image: 'assets/ui/match2/common/cell.png',
      height: 120,
      width: 491,
      scaleMethod: '9slice',
      sourceSlices: {
        horizontal: { left: 30, right: 30 },
        vertical: { top: 30, bottom: 30 },
      },
      ...opts,
    });

    let icon: View | null = null;
    const boosterType = booster.type;
    switch (boosterType) {
      case 'dart':
      case 'bullet':
      case 'drill':
      case 'roulette':
        icon = this.createBoosterIcon(boosterType, booster.quantity);
        break;

      default:
        assertNever(boosterType);
    }

    icon.updateOpts({
      x: icon.style.width / 2 + 10,
      y: this.style.height / 2,
      centerOnOrigin: true,
    });

    // icon
    this.addSubview(icon);

    this.addSubview(
      new LangBitmapFontTextView({
        font: 'Body',
        color: '#BF8147',
        x: 285,
        y: this.style.height / 2,
        centerOnOrigin: true,
        size: 30,
        height: 100,
        width: 350,
        localeText: () =>
          i18n(`match2.boosters.purchase.${boosterType}.message`, booster),
        verticalAlign: 'center',
        align: 'left',
        wordWrap: true,
      }),
    );
  }

  private createBoosterIcon(type: Match2BoosterType, quantity: number) {
    const bg = new ImageScaleView({
      width: 91,
      height: 95,
      image: matchTheme().getUIAsset('booster_frame.png'),
    });

    new ImageScaleView({
      superview: bg,
      width: 90,
      height: 90,
      image: matchTheme().getBoosterIcon(type),
      centerOnOrigin: true,
      x: bg.style.width / 2,
      y: bg.style.height / 2,
    });

    new LangBitmapFontTextView({
      superview: bg,
      font: 'Title',
      color: '#FFFFFF',
      size: 30,
      width: 90,
      height: 36,
      align: 'right',
      verticalAlign: 'center',
      y: bg.style.height - 30,
      localeText: () => `×${quantity}`,
    });

    return bg;
  }
}
